// styles
import styled from "@emotion/styled";
import mixins from "theme/mixins";
import Dropdown from "components/dropdown";

export const StyledCustomDropdown = styled(Dropdown)`
  width: 100%;
  ${mixins.fontCoda()};
  color: ${(props) => props.theme.white};

  border-radius: 0;
`;

